import { Flex, Badge, Text } from '@radix-ui/themes';

const SegmentSeparator = ({ isLast, isSecondToLast }) => {
  if (isSecondToLast) {
    return (
      <Text weight="bold" style={{ padding: '0 4px' }}>
        {' '}
        OR{' '}
      </Text>
    );
  }
  if (!isLast) {
    return (
      <Text color="gray" style={{ padding: '0 4px' }}>
        ,{' '}
      </Text>
    );
  }
  return null;
};

const SegmentGroup = ({ segments }) => (
  <Flex gap="1" align="center" display="inline-flex">
    {segments.map((seg, index) => (
      <Flex key={index} gap="0" align="center" display="inline-flex">
        {index === 0 && '('}
        <Badge color="gray" variant="soft">
          {seg.name}
        </Badge>
        <SegmentSeparator
          isLast={index === segments.length - 1}
          isSecondToLast={index === segments.length - 2}
        />
        {index === segments.length - 1 && ')'}
      </Flex>
    ))}
  </Flex>
);

const MultipleGroups = ({ segmentGroups }) => (
  <Flex gap="2" wrap="wrap" align="center">
    {segmentGroups.map((group, groupIndex) => (
      <Flex key={groupIndex} gap="1" align="center" display="inline-flex">
        {groupIndex > 0 && <Text weight="bold"> AND </Text>}
        <SegmentGroup segments={group.segments} />
      </Flex>
    ))}
  </Flex>
);

const SingleGroup = ({ segments }) => (
  <Flex gap="2" wrap="wrap" align="center">
    {segments.map((seg, index) => (
      <Badge key={index} color="gray" variant="soft">
        {seg.name}
      </Badge>
    ))}
  </Flex>
);

const LegacyAudiences = ({ population }) => (
  <Flex gap="2" wrap="wrap" align="center">
    {population.map((seg, index) => (
      <Badge key={index} color="gray" variant="soft">
        {seg.label}
      </Badge>
    ))}
  </Flex>
);

export const AudienceSummary = ({ audience }) => {
  if (!audience) {
    return null;
  }

  // New format with segment groups
  if (audience.segmentGroups && audience.segmentGroups.length > 0) {
    if (audience.segmentGroups.length > 1) {
      return <MultipleGroups segmentGroups={audience.segmentGroups} />;
    }
    return <SingleGroup segments={audience.segmentGroups[0].segments} />;
  }

  // Legacy format with population
  if (audience.population && audience.population.length > 0) {
    return <LegacyAudiences population={audience.population} />;
  }

  return null;
};
